import React from 'react';

import { useIntl } from 'react-intl';

interface ErrorMessageProps {
    message?: string;
    messageId?: string;
    type?: 'danger' | 'warning';
}

const typeStyles = {
    danger: 'tw-bg-danger/10 tw-text-danger',
    warning: 'tw-bg-warning/10 tw-text-warning',
};

export const ErrorMessage = ({ message, messageId, type = 'danger' }: ErrorMessageProps) => {
    const intl = useIntl();

    if (!message && !messageId) return null;

    const displayText = messageId
        ? intl.formatMessage({ id: messageId, defaultMessage: message })
        : (message ?? '');

    return (
        <div
            role="alert"
            className={`tw-flex tw-items-start tw-gap-8 tw-mt-12 tw-p-12 tw-rounded tw-text-s ${typeStyles[type]}`}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="tw-w-[16px] tw-h-[16px] tw-shrink-0 tw-mt-[1px]"
            >
                <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                    clipRule="evenodd"
                />
            </svg>
            <span>{displayText}</span>
        </div>
    );
};
